
const userProfileRouter = [
  {
    path: '/user-profile',
    name: 'UserProfile',
    component: () => import('@/views/wxapp/user-profile'),
    meta: {
      title: '用户档案'
    },
    children: [
      {
        path: 'userInformation',
        name: 'UserInformation',
        component: () => import('@/views/wxapp/user-profile/userInformation'),
        meta: {
          title: '用户档案'
        }
      },
      {
        path: 'userDetails',
        name: 'UserDetails',
        component: () => import('@/views/wxapp/user-profile/userDetails'),
        meta: {
          title: '房屋信息'
        }
      },
      {
        path: 'message-confirmation',
        name: 'ConfirmationMessage',
        component: () => import('@/views/wxapp/user-profile/pre-message'),
        meta: {
          title: '预上门用户'
        }
      },
      {
        path: 'follow-recode',
        name: 'FollowRecode',
        component: () => import('@/views/wxapp/user-profile/userDetails/follow-recode'),
        meta: {
          title: '跟进记录'
        }
      }
    ]
  }
]
export default userProfileRouter
